import { Clickable, Dropdown, Row, Text } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import TierAssignmentsList from './TierAssignmentsList';

const TierAssignments = ({ athleteTiers = [] }) => {
  const [loading, setLoading] = useState(false),
    [selectedTier, setSelectedTier] = useState('All'),
    [teams, setTeams] = useState([]),
    tierAssignments = useSelector((state) => state?.admin?.tierAssignments),
    dispatch = useDispatch(),
    fetching = useRef(false),
    { t } = useTranslation();

  useEffect(() => {
    getTeams().then(getTierAssignments('all').then());
  }, []);

  async function getTierAssignments(tier) {
    dispatch({
      type: 'ADMIN_SET_TIER_ASSIGNMENTS',
      payload: []
    });

    if (fetching.current) {
      return;
    }

    setLoading(true);
    fetching.current = true;

    const requestPayload =
      tier === 'all'
        ? { type: 'athlete', paymentType: 'shoutoutFromAthlete', withTier: true, noSkip: true }
        : { type: 'athlete', tier, noSkip: true };

    /**
     * @property {number} length
     */
    const res = await Api.post(`/admin/getUsers`, requestPayload);

    fetching.current = false;
    setLoading(false);

    if (!res || res.length === 0) {
      return;
    }

    dispatch({
      type: 'ADMIN_ADD_TIER_ASSIGNMENTS',
      payload: res
    });
  }

  async function getTeams() {
    setLoading(true);

    const res = await Api.post(`/admin/getUsers`, { type: 'team', noSkip: true });

    setLoading(false);

    if (!res || res.length === 0) {
      return;
    }

    setTeams(res);
  }

  function setTier(value) {
    setSelectedTier(value.name);
    getTierAssignments(value.id).then();
  }

  return (
    <div style={{ padding: 16, paddingTop: 32 }}>
      <Row pad="0 16px">
        <Text h4>Tier Assignments</Text>
      </Row>

      <hr />

      <Row end between pad="16px 0">
        <Dropdown
          admin
          title="Select Tier"
          wid="300px"
          selected={selectedTier}
          options={
            athleteTiers?.length
              ? [{ id: 'all', name: 'All' }, ...athleteTiers]
              : [{ id: 'all', name: 'All' }]
          }
          handleSelect={setTier}
          rounded
          small
        />

        <Clickable onClick={() => {}}>
          <Row noFlex bg={theme.SECONDARY} pad="9px 24px" hasRadius="32px" marg="0 8px 0 0">
            <Text med col="#fff">
              Add Athletes to Tier
            </Text>
          </Row>
        </Clickable>
      </Row>

      <Row>
        <TierAssignmentsList
          data={tierAssignments}
          teams={teams}
          dataId={null}
          onClick={() => {}}
          loading={loading}
        />
      </Row>

      <Row centerAll pad="24px">
        {tierAssignments?.length === 0 && <Text h5>{t('chat.noResults')}</Text>}
      </Row>
    </div>
  );
};

export default TierAssignments;
